export const fileFormatGroups = {
  invoice: {
    accept: ".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg",
    label: "Obsługiwane formaty: PDF, PNG, JPG, JPEG.",
    extensions: ["pdf", "png", "jpg", "jpeg"],
  },
  pdfOrImage: {
    accept: ".pdf,.png,.jpg,.jpeg,.gif,application/pdf,image/png,image/jpeg,image/gif",
    label: "Obsługiwane formaty: PDF, PNG, JPG, JPEG, GIF.",
    extensions: ["pdf", "png", "jpg", "jpeg", "gif"],
  },
  pdfOnly: {
    accept: ".pdf,application/pdf",
    label: "Obsługiwany format: PDF.",
    extensions: ["pdf"],
  },
  csv: {
    accept: ".csv,text/csv",
    label: "Obsługiwany format: CSV.",
    extensions: ["csv"],
  },
  json: {
    accept: ".json,application/json",
    label: "Obsługiwany format: JSON.",
    extensions: ["json"],
  },
  xlsx: {
    accept: ".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    label: "Obsługiwany format: XLSX.",
    extensions: ["xlsx"],
  },
};

export function getFileExtension(fileName) {
  const parts = String(fileName || "").split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
}

export function hasAllowedFileExtension(file, allowedExtensions) {
  if (!file) return false;
  return allowedExtensions.includes(getFileExtension(file.name));
}

export function filterAllowedFiles(files, allowedExtensions) {
  const list = Array.from(files || []);
  return {
    accepted: list.filter((file) =>
      hasAllowedFileExtension(file, allowedExtensions),
    ),
    rejected: list.filter(
      (file) => !hasAllowedFileExtension(file, allowedExtensions),
    ),
  };
}

export function formatRejectedFilesMessage(rejected, label) {
  const names = Array.from(rejected || [])
    .map((file) => file.name)
    .join(", ");
  return `${label} Odrzucone pliki: ${names || "nieobsługiwany format"}.`;
}
